// --------------------------------------------------------------
// Created On: 2021-09-21
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { CSSProperties } from "react";
import { Modal as ModalReact } from "react-bootstrap";

// Generic modal.
export default function Modal(props: Props): Component {
  return (
    <ModalReact
      dialogClassName={props.dialogClassName || undefined}
      backdropClassName={props.backdropClassName || undefined}
      show={props.show}
      onHide={props.onHide}
      size={props.size || undefined}
      animation={props.animation || undefined}
      centered={props.centered || undefined}
      style={props.style || undefined}
    >
      {props.children}
    </ModalReact>
  );
}

interface Props {
  show: boolean;
  onHide: () => void;
  dialogClassName?: string;
  backdropClassName?: string;
  size?: "sm" | "lg" | "xl";
  animation?: boolean;
  centered?: boolean;
  children?: Children;
  style?: CSSProperties;
}
